// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shortcut"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.1213 14.1213L19.638 8.60452C19.9142 8.09262 20.4852 6.3431 19.071 4.92888C17.6568 3.51467 15.9073 4.08568 15.3954 4.36188L14.5197 5.23756M9.87863 9.87863L4.36188 15.3954C4.08568 15.9073 3.51467 17.6568 4.92888 19.071C6.34309 20.4852 8.09262 19.9142 8.60452 19.638L9.4802 18.7623M14.1213 9.87863L8.60452 4.36188C8.09262 4.08568 6.34309 3.51467 4.92888 4.92888C3.51467 6.34309 4.08568 8.09262 4.36188 8.60452L5.23756 9.4802M9.87863 14.1213L15.3954 19.638C15.9073 19.9142 17.6568 20.4852 19.071 19.071C20.4852 17.6568 19.9142 15.9073 19.638 15.3954L18.7623 14.5197","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ShortcutIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shortcut',
    ref,
    icon: element,
  },
));

ShortcutIcon.displayName = 'ShortcutIcon';

export default ShortcutIcon;
